<template>
  <div v-if="data.more.can_action && !data.parent_id" :class="`form-group edit-status row-action w-100 ${data.status}`">
    <!-- raw -->
    <div v-if="['raw', 'reject'].indexOf(data.more.can_action) !== -1" class="position-relative d-flex w-100">
      <Select source="user/search" type="auto" field="design.designer_read" placeholder="Designer" :value="data.designer_id || null" @changeValue="handleChangeDesigner" class="flex-1 mr-2"></Select>
      <a @click.prevent="submit('confirm')" href="#" class="btn btn-outline-success d-flex align-items-center">
        <span>Confirm</span>
      </a>
    </div>

    <!-- confirm -->
    <div v-if="['confirm'].indexOf(data.more.can_action) !== -1" class="position-relative d-flex w-100">
      <a @click.prevent="submit('reject')" href="#" class="btn btn-outline-light mr-2">
        <span>Cancel</span>
      </a>
      <a @click.prevent="submit('doing')" href="#" class="btn btn-outline-success">
        <span>Confirm</span>
      </a>
    </div>

    <!-- doing -->
    <div v-if="['doing', 'remake'].indexOf(data.more.can_action) !== -1" class="position-relative d-flex flex-wrap w-100">
      <div class="w-100">
        <input class="form-control flex-1" :value="designUrl" @change="changeDesignInput" ref="DesignUrl" placeholder="Design url" />
      </div>
      <ButtonUpload :config="{ multiple: true, uploadFromUrl: false, group: false }" @changeValue="addDesignFiles" class="flex-1 mt-2 mr-2"></ButtonUpload>
      <a @click.prevent="submit('design-review')" href="#" class="btn btn-outline-success mt-2">
        <span>Confirm</span>
      </a>
      <div class="w-100 mt-2 d-flex">
        <a @click.stop.prevent="clickGroupDesign" href="#" class="btn btn-outline-primary w-100 mr-2">
          <span>Group Design</span>
        </a>
      </div>
      <ThumbnailPreview :value="designFile" @changeValue="changeDesignFiles" class="design-thumbnail mt-1" editable></ThumbnailPreview>
      <UploadArtwork :value="artworkFile" @change="changeArtworkFiles"></UploadArtwork>
    </div>

    <!-- design-review -->
    <div v-if="['design-review'].indexOf(data.more.can_action) !== -1" class="w-100">
      <div v-if="!causeVisibility" class="position-relative d-flex w-100" ref="designReviewBtn">
        <a @click.prevent="causeVisibility = true" href="#" class="btn btn-outline-warning mr-2">
          <span>Reject</span>
        </a>
        <a @click.prevent="submit('mapping')" href="#" class="btn btn-outline-success">
          <span>Mapping</span>
        </a>
      </div>
      <CauseRefusal v-if="causeVisibility" @changeValue="handleChangeCause('remake', $event)" @hiddenVisibility="causeVisibility = false" />
    </div>

    <!-- mapping -->
    <div v-if="['mapping'].indexOf(data.more.can_action) !== -1" class="w-100">
      <div v-if="!causeVisibility" class="position-relative d-flex w-100 flex-wrap">
        <div class="p-0 m-0 w-100 supplier-account" ref="supplierAccount">
          <Select :options="vendorOptions" :group="true" placeholder="Account" v-model="mapping.vendor_id" @changeValue="handleChangeVendorId" class="flex-1"></Select>
        </div>
        <component :is="component" :config="designMappingConfig()" @changeValue="designMappingChange" @indexSupplier="indexVendorId"></component>
        <div class="flex-wrap m-0 mt-2 w-100">
          <div class="position-relative d-flex w-100" ref="mappingBtn">
            <a v-if="data.refer_order" @click="handlePrint" href="#" class="btn mr-2 btn-outline-warning">
              <span>Print</span>
            </a>
            <a v-if="reCompleted" @click.prevent="submit('re-completed')" href="#" class="btn mr-2 btn-outline-light">
              <span>Use pre-mapping</span>
            </a>
            <a @click.prevent="causeVisibility = true" href="#" class="btn mr-2 btn-outline-warning">
              <span>Redesign</span>
            </a>
            <a @click.prevent="submit('completed')" href="#" class="btn mr-2 btn-outline-success">
              <span>Confirm</span>
            </a>
          </div>
        </div>
      </div>
      <CauseRefusal v-if="causeVisibility" @changeValue="handleChangeCause('remake', $event)" @hiddenVisibility="causeVisibility = false" />
      <div v-if="printMethodOptions?.length > 0" class="position-relative form-group print-methods col-12 p-0 m-0 mt-2 mb-3">
        <label class="col-12 mb-0 p-0 font-weight-bold d-block">Print Method</label>
        <div class="btn-group-sm nav btn-group mt-2 d-inline-block">
          <div v-for="(object, index) in printMethodOptions" :key="index" class="radio-container btn-shadow btn show p-0 mb-1">
            <input type="radio" name="print_method" :value="object.id" :checked="data.print_method == object.id" @change="handleChangePrintMethod(object.id)" />
            <span href="#" class="checkmark p-2" style="min-width: 50px">{{ object.text }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- completed -->
    <div v-if="['completed'].indexOf(data.more.can_action) !== -1" class="w-100">
      <div v-if="!causeVisibility" class="position-relative d-flex w-100">
        <a @click.prevent="submit('re-sync')" href="#" class="btn btn-outline-warning mr-2"><span>Resync design</span></a>
        <a @click.prevent="causeVisibility = true" href="#" class="btn btn-outline-success"><span>Update design mapping</span></a>
      </div>
      <CauseRefusal v-if="causeVisibility" @changeValue="handleChangeCause('mapping', $event)" @hiddenVisibility="causeVisibility = false" />
    </div>

    <div class="sub-designs">
      <div v-if="data?.sub_designs && data?.sub_designs?.length > 0" class="form-group">
        <label class="col-12 mb-0 p-0">Sub Designs:</label>
        <ul class="list-sub-design">
          <li v-for="(subDesign, index) in data.sub_designs" :key="index" @click="clickSubDesign(subDesign)">
            <div class="sub-design-item">
              <div class="design-thumbnail">
                <Image :src="srcImage(subDesign.thumbnail, 'thumbnail')" />
              </div>
              <div class="design-metadata">
                <div class="design-title">{{ subDesign.name || `#${subDesign.id}` }}</div>
                <div class="design-quantity">Quantity: {{ subDesign.quantity }}</div>
              </div>
            </div>
            <a v-if="['doing', 'remake'].indexOf(data.more.can_action) !== -1" @click.stop.prevent="clickSplitDesign(subDesign.id)" href="#close"> <i class="ti ti-x"></i></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
import print from '@/helper/print.js'
import ButtonUpload from '@/components/ButtonUpload.vue'
import ThumbnailPreview from '@/components/ThumbnailPreview.vue'
import CauseRefusal from './CauseRefusal.vue'
import UploadArtwork from '@/components/UploadArtwork.vue'

export default {
  mixins: [Event],
  components: {
    ButtonUpload,
    ThumbnailPreview,
    CauseRefusal,
    UploadArtwork
  },
  data() {
    /* prettier-ignore */
    return {
      causeVisibility: false,
      submitStructure: [
        'status',
        'designer_id',
        'design_files',
        'cause',
        'mapping',
        'artwork_files',
        'print_method'
      ],
      component: null,
      vendorOptions: [],
      storeInVendorOptions: [],
      storeProductList: [],
      storeProductId: null,
      reCompleted: false,
      mapping: {},
      cause: null,
      mappingPlatform: null,
      submited: false
    }
  },
  mounted() {
    this.$emitter.on('Modal.Design.Refresh', this.initialization)
  },
  beforeUnmount() {
    this.$emitter.off('Modal.Design.Refresh', this.initialization)
    if (this.submited) {
      this.$emitter.emit('TableList.Refresh')
    }
  },
  computed: {
    storeId() {
      return this.config?.storeId
    },
    designId() {
      return this.config?.designId
    },
    submitUri() {
      return `design/update-status/${this.designId}`
    },
    data() {
      return this.config?.data
    },
    status() {
      return this.data?.status
    },
    more() {
      return this.data?.more || {}
    },
    designUrl() {
      return this.data?.design_files?.[0] || ''
    },
    designFile() {
      return this.$util.filter(this.data.design_files || [], ({ item }) => {
        return _.isObjectLike(item)
      })
    },
    artworkFile() {
      return this.data.artwork_files || {}
    },
    printMethodOptions() {
      return Object.values(this.store.getter('extra_attributes.print_methods', {}))
    }
  },
  methods: {
    srcImage(image, size) {
      if (String(image).length > 0) {
        if (Object.keys(this.$util.options.extension.image).includes(this.$util.getExtensionFromString(image))) {
          return this.$util.addQueryParam(String(image), { size })
        }
      }
      return defaultPreview
    },
    clickSubDesign(subDesign) {
      this.$emitter.emit('Modal', {
        name: 'design.view',
        data: {
          _id: subDesign.id
        },
        storeId: this.storeId.slice(0, this.storeId.length - 1).concat(`sub-design-view`),
        $el: this.$el
      })
    },
    clickGroupDesign() {
      this.$emitter.emit('Modal', {
        name: 'design.group-design',
        $el: this.$el.closest('tr.item'),
        data: {
          id: this.config?.designId,
          sub_design: this.data?.sub_design || []
        }
      })
    },
    clickSplitDesign(subDesignId) {
      if (!window.confirm('Are you sure to split sub-design?')) return false
      this.$util
        .post(`design/split-design/${this.designId}`, {
          ids: [subDesignId]
        })
        .then((response) => {
          if (response.status == 'success') {
            const sub_designs = this.store.getter('sub_designs', []).filter((design) => design.id != subDesignId)
            this.store.commit('sub_designs', sub_designs)
          } else {
            console.log(response)
          }
        })
      return false
    },
    toggleVisibility(shows = null, hides = null) {
      if (shows != null) {
        if (!_.isArray(shows)) {
          shows = [shows]
        }
        shows.forEach((show) => {
          show.classList.remove('hide')
        })
      }
      if (shows != null) {
        if (!_.isArray(hides)) {
          hides = [hides]
        }
        hides.forEach((hide) => {
          hide.classList.add('hide')
        })
      }
    },
    handleChangeDesigner(value) {
      this.store.commit('designer_id', value)
    },

    addDesignFiles(values) {
      this.store.commit('design_files', Object.assign({}, this.data.design_files, values))
    },
    changeDesignFiles(values) {
      this.store.commit('design_files', values)
    },
    changeArtworkFiles(values) {
      this.store.commit('artwork_files', values)
    },
    changeDesignInput(e) {
      if (!_.isObjectLike(this.data.design_files) || this.data.design_files === null) {
        this.store.commit('design_files', {})
      }
      let designFiles = this.store.getter('design_files', {})
      if (Object.keys(designFiles).length > 0 && designFiles[0] == undefined) {
        if (confirm('File already exists. Do you want to delete?') != true) {
          e.currentTarget.value = ''
          return false
        }
      }
      this.store.commit('design_files', {
        0: e.currentTarget.value
      })
    },
    handleChangeCause(status, value) {
      this.cause = value
      this.submit(status)
    },
    indexVendorId() {
      if (this.data.status == 'mapping') {
        if (this.data.mapping && this.data.mapping.vendor_id) {
          this.reCompleted = true
        } else {
          this.reCompleted = false
        }
        this.$util.get(
          'vendor-account',
          {},
          this.$refs.supplierAccount,
          {
            done: (response) => {
              if (response.status == 'success') {
                this.vendorOptions = Object.values(response.items)
                if (!this.store.getter('mapping.vendor_id', '') && this.$util.getObjectVal(this.vendorOptions, '0.children.0.id') != null) {
                  this.handleChangeVendorId(this.vendorOptions[0].children[0].id)
                } else {
                  this.handleChangeVendorId(this.data.mapping.vendor_id)
                }
              } else {
                console.log(response)
              }
            }
          },
          {},
          { force: true }
        )
      } else {
        this.vendorOptions = []
      }
    },
    designMappingConfig() {
      return {
        storeId: this.storeId,
        data: this.data,
        mapping: Object.assign({}, this.data.mapping || {}, this.mapping),
        platform: this.mappingPlatform
      }
    },
    handleChangePrintMethod(value) {
      this.data.print_method = value
    },
    handleChangeVendorId(value) {
      if (value !== null) {
        this.mapping.vendor_id = value
        this.vendorOptions.forEach((items) => {
          if (!_.isUndefined(items.children)) {
            items.children.forEach((item) => {
              if (!_.isUndefined(item.id) && item.id == value) {
                this.mappingPlatform = item.platform
              }
            })
          } else {
            if (!_.isUndefined(items.id) && items.id == value) {
              this.mappingPlatform = items.platform
            }
          }
        })
      } else {
        this.mappingPlatform = null
      }

      this.component = null
      if (this.mappingPlatform) {
        this.mapping.is_valid = 0

        let platform = _.pascalCase(this.mappingPlatform || '')
        let component = `${platform}.Design.DesignMapping`
        if (this.$options.components[component] == undefined) {
          this.$options.components[component] = this.$util.requireOrNull(`/platforms/${platform}/Design/DesignMapping.vue`)
        }

        if (this.$options.components[component] !== null) {
          this.component = component
        } else {
          this.$util.notify({
            text: 'Platforms not supported!',
            status: 'error'
          })
        }

        this.$emitter.emit('Modal.Design.ChangeSupplier')
        this.mapping.vendor_id = value
      }
    },
    designMappingChange(value) {
      this.mapping = Object.assign({}, this.mapping, value)
    },
    handlePrint() {
      let order = _.cloneDeep(this.data.refer_order)
      order.line_items = _.filter(order.line_items, (item) => {
        return this.data.id == item.design_id
      })
      print.order(order)
    },
    submit(status) {
      if (status != 'completed' || this.mapping.is_valid || window.confirm('The mapping product does not match. Are you sure to use?')) {
        let data = Object.assign({}, this.data, {
          cause: this.cause
        })
        if (status == 're-completed') {
          status = 'completed'
        } else if (status == 'completed') {
          data = Object.assign({}, data, {
            mapping: Object.assign({}, this.data.mapping, this.mapping)
          })
        }
        this.submited = false
        this.submitForm(
          Object.assign({}, data, {
            status
          }),
          {
            done: (response) => {
              if (response.status == 'success') {
                this.store.commit('', response.data)
                this.store.commit('extra_attributes', response.extra_attributes)
                if (this.data.status == 'mapping' && this.data.mapping && this.data.mapping.vendor_id) {
                  this.reCompleted = true
                } else {
                  this.reCompleted = false
                }
              } else {
                console.log(response)
              }
            },
            finally: () => {
              this.submited = true
              this.cause = null
            }
          },
          {
            $el: this.$el
          }
        )
      }
    }
  },
  props: {
    config: Object
  },
  watch: {
    status(value) {
      this.causeVisibility = false
      if (value == 'mapping') {
        this.indexVendorId()
      }
    }
  }
}
</script>
<style lang="scss">
.upload-front-btn,
.upload-back-btn,
.upload-cut-btn {
  button,
  .dropdown-menu {
    display: none !important;
  }
}
.design-details {
  .sub-designs {
    width: 100%;
    .list-sub-design {
      list-style: none;
      padding: 10px 0 0 0;
      margin: 0;
      cursor: pointer;
      [href='#close'] {
        display: none;
      }
      li {
        position: relative;
        &:hover [href='#close'] {
          display: block;
        }
      }
      .sub-design-item {
        display: flex;
        margin-bottom: 10px;
        border: 1px solid #009cff;
        background: #e0f3ff;
        border-radius: 18px;
        overflow: hidden;
      }

      i {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #000;
        color: #fff;
        position: absolute;
        z-index: 99;
        top: -5px;
        right: 0;
        border-radius: 50%;
        width: 22px;
        height: 22px;
        line-height: 1;
        font-size: 14px;
      }
    }
    .design-thumbnail {
      width: 68px;
      height: 68px;
      overflow: hidden;
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .design-metadata {
      display: inline-block;
      padding: 5px;
      .design-title {
        font-weight: bold;
      }
      .design-quantity {
        font-size: 0.9em;
        color: #666;
      }
    }
  }
  .radio-container,
  .checkbox-container {
    background-color: #deffde;
    color: #1a881d;
    input {
      &:checked ~ .checkmark {
        background-color: #26be2b;
        color: #fff;
      }
    }
  }
}
</style>
